module.exports = __webpack_public_path__ + "static/media/poster.4cf78e90.png";